import { useNavigate } from 'ice';
import { useStore } from '@/store';
import { getQueryStringByName, isGuesLogin } from '@/utils/helper';
import { ToastCloneFn } from '@/components/Toast';
import { ROUTER_MAP } from '@/types';
import { showLoginDrawer } from '@/components/Drawer';

export const useRouter = () => {
  const { baseObj, setBaseObj } = useStore();
  const isGues = isGuesLogin();
  const navigate = useNavigate();

  const getWapid = () => {
    // 那个有 用那个
    const urlWapid = getQueryStringByName('wapid');
    let temp = urlWapid || baseObj?.wapid;

    if (urlWapid && baseObj?.wapid) {
      // 都有的话 本地的优先
      if (urlWapid !== baseObj?.wapid) {
        temp = baseObj?.wapid;
      }
    }

    return temp;
  };

  const getCinemaId = () => {
    // 那个有 用那个
    const urlCinema = getQueryStringByName('cinemaId');
    // console.log(urlCinema);
    let temp = urlCinema || baseObj?.cinema?.cinemaLinkId;

    if (urlCinema && baseObj?.cinema?.cinemaLinkId) {
      // 都有的话 本地的优先
      if (urlCinema !== baseObj?.cinema?.cinemaLinkId) {
        temp = baseObj?.cinema?.cinemaLinkId;
      }
    }

    return temp;
  };

  function objectToUrlParams(obj) {
    let params = new URLSearchParams();
    for (let [key, value] of Object.entries(obj)) {
      params.append(key, value as any);
    }
    return params.toString();
  }


  const needLoginRouter = [ROUTER_MAP.ACTIVITY_DETAIL];

  const noLogin = !baseObj.user?.account?.accountId || isGues;


  const jump = (
    url: ROUTER_MAP | number,
    params?: {
      state?: any;
      query?: any;
      replace?: boolean;
    },
  ): void => {
    ToastCloneFn?.();


    if (needLoginRouter.includes(url as ROUTER_MAP) && noLogin) {
      showLoginDrawer();
      return;
    }


    if (url === -1) {
      navigate(-1);
      return;
    }
    const { state = {}, query = {}, replace = false } = params || {};

    const defaultQuery = {
      wapid: getWapid(),
      cinemaId: getCinemaId(),
    };

    const allQuery = {
      ...defaultQuery,
      ...query,
    };
    // 保存当前页面路由
    setBaseObj({
      ...baseObj,
      prePathname: window.location.pathname,
    });
    navigate(
      `${url}?${objectToUrlParams({
        ...allQuery,
      })}`,
      {
        replace: replace,
        state: {
          ...state,
        },
      },
    );
  };
  const reset = () => {
    const params = window.location.href.split('?')[1];
    let paramsData = Object.fromEntries(new URLSearchParams(params).entries());
    paramsData.cinemaId = baseObj?.cinema?.cinemaLinkId;
    navigate(`${window.location.pathname}?${objectToUrlParams(paramsData)}`, {
      replace: true,
    });
  };
  const url = new URL(window.location.href);
  return {
    jump: jump,
    reset,
    getCinemaId,
    getQueryValue: (name: string) => url.searchParams.get(name),
  };
};
